// extracted by mini-css-extract-plugin
export var deco1 = "Video-module--deco1--3d39e";
export var deco2 = "Video-module--deco2--02bae";
export var deco3 = "Video-module--deco3--6e0b7";
export var root = "Video-module--root--4c709";
export var windowIcon = "Video-module--windowIcon--b8cae";